import { RouterProvider, createHashRouter } from "react-router-dom";

import routes from "@/constants/routes";

// We use Hash router for cordova & to fix netlify error in subroutes:
// https://answers.netlify.com/t/problem-when-navigating-routing/98037/2
export const router = createHashRouter(routes);
// export const router = createBrowserRouter(routes);

const Router = () => {
    return <RouterProvider router={router} />;
};

export default Router;
